var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_335_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.667 11.5909L19.7725 10.8745L15.667 0.560791L11.5615 10.8745L0.666992 11.591L9.02586 18.6767L6.28356 29.4392L15.667 23.5086L25.0504 29.4392L22.3082 18.6772L30.667 11.5909ZM15.667 21.4291L9.0773 25.594L11.0008 18.0453L5.1101 13.0598L12.7842 12.5558L15.667 5.31368L18.5498 12.5558L26.2329 13.0598L20.3331 18.0448L22.2567 25.594L15.667 21.4291Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_335_46"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.666992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteStar);
export default __webpack_public_path__ + "static/media/whiteStar.1168bdc20f4fea948ad4ee313016d6e3.svg";
export { ForwardRef as ReactComponent };